import React, { useEffect, useState, createElement } from 'react';
import { ElegirPack } from './pages/ElegirPack';
type Language = 'es' | 'en';
const SITE_URL = 'https://bibliotecaprofesional.com/';
const LCP_IMAGE = 'https://res.cloudinary.com/dowzlbqlz/image/upload/f_auto,q_auto:eco,dpr_auto,w_400/v1779676327/nutri-Photoroom_lqu1oy.png';
const seoCopy = {
  es: {
    title: 'Biblioteca Profesional — Sistemas digitales para profesionales y estudiantes',
    description: 'Recursos digitales listos para usar: planes, sesiones, guías y actividades para Nutrición, Kinesiología, Estimulación Temprana, Psicología, Medicina y más.',
    keywords: 'biblioteca profesional, sistema digital, recursos digitales, nutrición, kinesiología, estimulación temprana, psicología, medicina, material clínico, planes de alimentación, guías de estudio',
    locale: 'es_AR'
  },
  en: {
    title: 'Biblioteca Profesional — Digital Systems for professionals and students',
    description: 'Ready-to-use digital resources: plans, sessions, guides and activities for Nutrition, Kinesiology, Early Stimulation, Psychology, Medicine and more.',
    keywords: 'professional library, digital system, digital resources, nutrition, kinesiology, early stimulation, psychology, medicine, clinical materials, study guides',
    locale: 'en_US'
  }
} as const;
function setMeta(name: string, content: string, useProperty = false) {
  const attribute = useProperty ? 'property' : 'name';
  let element = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${name}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, name);
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
}
function setLink(rel: string, href: string, attrs: Record<string, string> = {}) {
  const selector = `link[rel="${rel}"][href="${href}"]`;
  let element = document.head.querySelector<HTMLLinkElement>(selector);
  if (!element) {
    element = document.createElement('link');
    element.rel = rel;
    element.href = href;
    document.head.appendChild(element);
  }
  Object.entries(attrs).forEach(([key, value]) => element!.setAttribute(key, value));
}
function setJsonLd(id: string, data: unknown) {
  document.getElementById(id)?.remove();
  const script = document.createElement('script');
  script.id = id;
  script.type = 'application/ld+json';
  script.text = JSON.stringify(data);
  document.head.appendChild(script);
}
export function App() {
  const [language, setLanguage] = useState<Language>('es');
  const copy = seoCopy[language];
  useEffect(() => {
    document.documentElement.lang = language;
    document.title = copy.title;
    setMeta('description', copy.description);
    setMeta('keywords', copy.keywords);
    setMeta('robots', 'index, follow, max-image-preview:large');
    setMeta('viewport', 'width=device-width, initial-scale=1, viewport-fit=cover');
    setMeta('theme-color', '#F6F5F2');
    setMeta('og:title', copy.title, true);
    setMeta('og:description', copy.description, true);
    setMeta('og:type', 'website', true);
    setMeta('og:url', SITE_URL, true);
    setMeta('og:image', LCP_IMAGE, true);
    setMeta('og:locale', copy.locale, true);
    setMeta('og:site_name', 'Biblioteca Profesional', true);
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', copy.title);
    setMeta('twitter:description', copy.description);
    setMeta('twitter:image', LCP_IMAGE);
    setLink('canonical', SITE_URL);
    setLink('preconnect', 'https://res.cloudinary.com', {
      crossorigin: ''
    });
    setLink('dns-prefetch', 'https://res.cloudinary.com');
    setLink('preload', LCP_IMAGE, {
      as: 'image',
      fetchpriority: 'high'
    });
    setJsonLd('mp-jsonld-organization', {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'Biblioteca Profesional',
      url: SITE_URL,
      logo: LCP_IMAGE,
      description: copy.description
    });
  }, [copy, language]);
  return <ElegirPack language={language} onLanguageToggle={() => setLanguage(currentLanguage => currentLanguage === 'es' ? 'en' : 'es')} data-id="element-0" />;
}